import React, { Component } from 'react';
import ChartistGraph from './base-chart';
import Header from '../graph/header';
import getDefaultOptions from '../../get-chart-default-options';
import { getResolution, hasHourlyResolution, dayDiffResolution } from '../../get-resolution';

class RegistrationsChart extends Component {
  constructor(props, context) {
    super(props, context);
    var { analytics } = this.props;
    this.state = { resolution: analytics.resolution, newData: true };
  }
  static displayName = 'RegistrationsChart';

  // static propTypes = {
  //   analytics: PropTypes.instanceOf(AnalyticsModel).isRequired,
  //   spotId: PropTypes.string.isRequired,
  //   resolutionChange: PropTypes.func.isRequired,
  // };

  // static contextTypes = {
  //   executeAction: PropTypes.func.isRequired,
  // };

  onResolutionChange(resolution) {
    this.state.resolution = resolution;
    this.state.newData = false;
    this.props.resolutionChange(resolution, 'registrations');
  }

  render() {
    var { analytics, loading } = this.props;
    var fromDay = analytics.get('from_day');
    var toDay = analytics.get('to_day');
    var registrations = analytics.get('registrations');
    var points = registrations.points || [];
    var hasHourly = hasHourlyResolution(fromDay, toDay);
    var dayDiff = dayDiffResolution(fromDay, toDay);
    let resolution = this.state.newData ? registrations.resolution : this.state.resolution;
    resolution = getResolution(toDay, fromDay, resolution);
    this.state.newData = true;
    var data = {
      series: [{ chartType: 'registrations', data: points, type: 'registrations' }]
    };

    var numberOfpoints = points.length;
    var options = getDefaultOptions(
      'registrations',
      numberOfpoints,
      resolution,
      ['Registrations'],
      ['registrations']
    );
    var aspectRatio = 'ct-octave registrations-chart';

    return (
      <div>
        <Header
          resolutionChange={this.onResolutionChange.bind(this)}
          hasHourly={hasHourly}
          dayDiff={dayDiff}
          resolution={resolution}
          name="registrations"
          title="New Registrations"
        />
        <ChartistGraph
          className={aspectRatio}
          data={data}
          options={options}
          loading={loading}
          type="Line"
        />
      </div>
    );
  }
}

export default RegistrationsChart;
